var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('b-form-input',{staticClass:"w-100",attrs:{"required":true,"show-labels":false},on:{"input":val => (_vm.value = _vm.value.toUpperCase())},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }